export default {
  install(Vue, options) {
    Vue.prototype.$Vehicle = {
      MultiMapinvalidateSizeNum:0,
      FirstData:false,
      LockCommandPasswordShow:false,
      LockCommandPasswordStr:'',
      LockCommandType:'',
      UnitLineStateList:[],
      detailpagetype:'main',
      FleetGeofenceObj:[],
      FromSignalR:false,
      TimeZone:'',
      CommandResponse:'',
      WatchUnit:'',
      CommandText:'',
      CommandLoading:false,
      // VideoCloseNum:0,
      SingleMapShow:true,
      WatchUnitObj:[],
      UnitDetailtheadShow:[],
      UnitInfoList:[],
      ClearWatchUnit:false,
      FleetID:0,
      SubFleetvar:false,
      Iconcheckbox:'Iconcheckbox',
      MultiIconcheckbox:'Iconcheckbox',
      MultiViewChckbox:false,
      VehicleRange:3,
      SearchCarNum:0,
      SearchCartip:false,
      UnitListDetailShow:false,
      UnitIDs:[],
      UnitIDsNum:0,
      UnitIDsSubPageObj:[],
      UnitPageNum:0,
      CurrentPageHighNumber:0,
      search_car:'',
      CurrentUnitPage:0,
      UnitIDsArr:[],
      Allnum:0,
      ClickUnitID:'',
      ClickUnitInfo:{},
      UnitEventInfoList:[],
      LastEventID:0,
      LastEventTime:'',
      MousemoveActive:false,
      VideoObjectShow:false,
      CommandShow:false,
      UnitVideoShow:[{show:0.5,title:'Front'+' lens',cursor:'not-allowed'},{show:0.5,title:'Back'+' lens'.lens,cursor:'pointer'}],
      VideoObject:[
        // {
        //   src:jsonObject.MJPGServer + '/command/mjpg?ch=0&id=1111',
        //   Name:0,
        //   Videoindex:0
        // },
        // {
        //   src:jsonObject.MJPGServer +'/command/playback?file=20221017_131638_CH1.mp4',
        //   Name:1,
        //   Videoindex:1
        // },
      ],
      //udid:'',
      //credential:'',
      VideoPlateNumber:'',
      PageSize:100,
      PageSizeObj:[],
      POIlist:[],
      iconID:0,
      CommandList:[],
      syntax:0,
      SignalRCallNum:0,
      //取消上鎖解鎖命令
      CancelLockCommand(){
        this.LockCommandPasswordShow = false
      },
      //下命令錯誤
      SendCommandError(data){
        Vue.prototype.$Vehicle.CommandLoading = false
        Vue.prototype.$Vehicle.CommandResponse = Vue.prototype.$Global.langObj[Vue.prototype.$Global.lang].command_Error + ' detail:' +data.detail
      },
      //上鎖解鎖下命令錯誤
      LockCommandError(data){
        Vue.prototype.$Global.load = false
        alert(Vue.prototype.$Global.langObj[Vue.prototype.$Global.lang].command_Error + ' detail:' +data.detail)
      },
      //下上鎖解鎖命令
      LockCommand(Type){
        if(this.ClickUnitInfo.connectionState == 0){
          alert(Vue.prototype.$Global.langObj[Vue.prototype.$Global.lang].Offline)
          return
        }
        this.LockCommandPasswordShow = true
        this.LockCommandPasswordStr = ''
        this.LockCommandType = Type
      },
      //打密碼按OK 下上鎖解鎖命令
      LockCommandOKClick(){
        this.LockCommandPasswordShow = false
        var CommandText = ''
        switch (this.LockCommandType) {
          case 'Lock':
            CommandText = 'AT$LOCKCMD=1'
            break;
          case 'Unlock':
            CommandText = 'AT$LOCKCMD=0'
            break;        
          default:
            break;
        }
        Vue.prototype.$Global.load = true
        Vue.prototype.$APIjs.SendCommand(localStorage.getItem('token'),this.ClickUnitID,CommandText,this.SendCommandError,this.LockCommandPasswordStr).then(result=>{
          Vue.prototype.$Global.load = false
          alert(result.obj.response)
        })
      },
      //下命令
      SendCommand(){
        this.CommandLoading = true
        Vue.prototype.$APIjs.SendCommand(localStorage.getItem('token'),this.ClickUnitID,this.CommandText,this.SendCommandError).then(result=>{
          this.CommandResponse = result.obj.response
          this.CommandLoading = false
        })  
      },
      //取得命令列表
      Command(){
        if(!this.CommandShow){
          if(this.ClickUnitInfo.connectionState == 0){
            alert(Vue.prototype.$Global.langObj[Vue.prototype.$Global.lang].Offline)
            return
          }
          // console.log(this.ClickUnitInfo)
          if(this.ClickUnitInfo.fK_ProtoID != null){
            // console.log(this.ClickUnitInfo.fK_ProtoID)
            this.CommandList = []
            Vue.prototype.$APIjs.GetCommandList(localStorage.getItem('token'),this.ClickUnitInfo.fK_ProtoID,this.ClickUnitInfo.fleetID).then(result=>{
              // console.log(result.obj)
              // if(result.obj.commandList){
              //   this.CommandList = result.obj.commandList
              // }
              if(result.obj.atCommQuery){
                this.CommandList = result.obj.atCommQuery
              }
            })  
          }
          //關閉網頁操作
          Vue.prototype.$Global.Noneactive = 'None-active'
          this.CommandResponse = ''
          this.CommandText = ''
          this.CommandShow = true
          this.syntax = 0
        }else{
          //開啟網頁操作
          Vue.prototype.$Global.Noneactive = ''
          this.CommandShow = false
          this.CommandLoading = false
        }
      },
      //尋找附近車輛
      NearByVehicle(){
        if(this.UnitInfoList.length > 1){
          var distancearray=[]
          this.WatchUnit = []
          for(var i = 0 ; i< this.UnitInfoList.length;i++){
            var distance = Vue.prototype.$Global.distance(this.ClickUnitInfo.latitude,this.ClickUnitInfo.longitude,this.UnitInfoList[i].latitude,this.UnitInfoList[i].longitude,'K')
            distancearray.push({unitId:this.UnitInfoList[i].unitId,key:i,distance:distance})
          }
          distancearray.sort(function(a, b) {
              return parseFloat(a.distance) - parseFloat(b.distance);
          });
          for(var j= 1 ; j< jsonObject.NearByNum+1 ; j++){
            this.UnitInfoList[distancearray[j].key].checkbox = 'true'
            this.UnitInfoList[distancearray[j].key].Iconcheckbox = 'Iconcheckbox-active'
          }
          var WatchUnitObj = this.getWatchUnit()
          //直接作用Multifocus
          Vue.prototype.$Global.Multifocus(WatchUnitObj)//multifocus
        }
        //關閉屬性框
        this.UnitListDetailShow = false
        this.CommandShow = false //關閉Command
      },
      //依據中心位置取最近5輛車
      FilterNearByVehicle(UnitList){
        var UnitList_ = []
        if(UnitList.length>0){
          var Center =  Vue.prototype.$Global.GetMapPosition()
          var distancearray=[]
          for(var i = 0 ; i< UnitList.length;i++){
            var distance = Vue.prototype.$Global.distance(Center.Lat,Center.Lng,UnitList[i].latitude,UnitList[i].longitude,'K')
            distancearray.push({unitId:UnitList[i].unitId,key:i,distance:distance})
          }
          distancearray.sort(function(a, b) {
              return parseFloat(a.distance) - parseFloat(b.distance);
          });
          for(var j= 0 ; j< jsonObject.NearByNum ; j++){
            UnitList_.push(UnitList[distancearray[j].key])
          }
          // console.log(UnitList_)
          // console.log(Center)
          // console.log(UnitList)
        }
        return UnitList_
      },
      //多車監控
      AllMultiViewcheckboxfunc(){
        this.CloseVideo()
        if(!this.MultiViewChckbox){
          this.MultiIconcheckbox = 'Iconcheckbox'
          this.SingleMapShow = true
          switch (Vue.prototype.$Global.MapType) {
            case 'Leaflet':
              setTimeout(() => {//地圖自適應視窗大小
                Vue.prototype.$LeafletMap.FMap.invalidateSize()
              }, 100);
              break;
            default:
              break;
          }
        }else{
          this.MultiIconcheckbox='Iconcheckbox-active'
          this.SingleMapShow = false
        }
      },
      //關閉影片
      CloseVideo(){
        this.OpenEventVideolog = false // 紀錄關閉 Event Video
        this.VideoObjectShow = false
        this.VideoObject = []
        // this.setUnitVideoShow()
      },
      //打開全部影片
      // OpenALLVideo(){
      //   this.VideoPlateNumber = this.ClickUnitInfo.identifier
      //   this.VideoObject = []
      //   var udid =  this.ClickUnitInfo.udid.substring(0, 40)
      //   var credential = encodeURIComponent(this.ClickUnitInfo.credential)
      //   for(var i =0;i<this.UnitVideoShow.length;i++){
      //     // this.VideoObject.push({src:'../../static/images/video/CH1_20211207051202_20211207051217_2_0_2_1.mp4',Name:(i+1)+' lens',Videoindex:i})
      //     this.VideoObject.push(
      //       {
      //         //src:'https://asia-player-tutkstg.kalay.us/player/test?udid=TUTKPITDUJH2ABIVIPLTCBQ5YLEVJSHXA7NF2TXM&credential=gL7YYGg5uovIeWM1D4WCNIyFyTWA0QA%2FICQeEHkmHgRhOWkr7O0Zt1ewDU1IlwKbF9aulR1FIrLMiNA5RXQNWLBpdnB825VfKlh6NyoCRHhmKbc1XkA8Uo4P3szchUy1hYnzrR4R9BHIQmiNnTVmN7PxEatqq8pazaIh4NIDZIHOSEONsAUtx7mzb4YCFmVEuxOafclNthz2RV71wixO342z2xXo%2B%2B7QDZEI2w64Xqk%3D&channelNo='+i+'&channelName=F-CAM%20Live',
      //         src:'https://asia-player-tutkstg.kalay.us/player/test?udid=' +  udid + '&credential='+ credential +'&channelNo='+ i +'&channelName='+ (i+1) +'-CAM%20Live',
      //         Name:(i+1)+' '+Vue.prototype.$Global.langObj[Vue.prototype.$Global.lang].lens,
      //         Videoindex:i
      //       }
      //     )
      //     this.UnitVideoShow[i].show = 1
      //   }
      //   this.VideoObjectShow = true
      // },
      //打開事件影片
      OpenEventVideo(Obj,index){//Obj:event Obj\
        this.OpenEventVideolog = true
        this.VideoObjectShow = false
        this.VideoPlateNumber = Obj.identifier
        this.VideoObject = []
        // this.setUnitVideoShow()
        this.GetEventMPG(index,Obj)
      },
      //取得事件影片資訊
      GetEventMPG(index,Obj){
        var lensname = ''
        var mp4 = ''
        Vue.prototype.$APIjs.GetEventMPG(localStorage.getItem('token'),Obj.unitId,Obj.positionDateTimeGMT.replace('T', ' '),index+1,1).then(result=>{
          mp4 = result.obj
          lensname = Vue.prototype.$Global.OneConvertToFirst(index+1)
          //console.log(mp4)
          // var myConnection = new URL(mp4);
          // myConnection.username = "otus"
          // myConnection.password = "Tech1599"
          this.VideoObject.push({src:mp4,Name:lensname+' '+Vue.prototype.$Global.langObj[Vue.prototype.$Global.lang].lens,Videoindex:index.toString()})
          this.VideoObject = Vue.prototype.$Global.sortByKey(this.VideoObject,'Videoindex')
          //console.log('../../static/images/video/'+mp4)
          this.VideoObjectShow = true
          // console.log(this.VideoObject)
          // console.log(this.VideoObjectShow)
        })
      },
      //打開單一live
      OpenVideo(item,index){
        this.VideoPlateNumber = this.ClickUnitInfo.identifier
        //舊程式
        // if(this.OpenEventVideolog){
        //   this.VideoObject = []
        //   this.OpenEventVideolog = false
        // }
        //舊程式
        // var udid =  this.ClickUnitInfo.udid.substring(0, 40)
        // var credential = encodeURIComponent(this.ClickUnitInfo.credential)
        //舊程式
        //舊程式 
        // if(item.show == 0.5){
        //   item.show = 1
        //   this.VideoObject.push(
        //   {
        //     src:'https://asia-player-tutkstg.kalay.us/player/test?udid=' +  udid + '&credential='+ credential +'&channelNo='+ index +'&channelName='+Vue.prototype.$Global.OneConvertToFirst(index+1)+'-CAM%20Live',
        //     Name:Vue.prototype.$Global.OneConvertToFirst(index+1)+' '+Vue.prototype.$Global.langObj[Vue.prototype.$Global.lang].lens,
        //     Videoindex:index
        //   })
        // }else if(item.show == 1){
        //   for(var i=0 ;i<this.VideoObject.length;i++){
        //     if(this.VideoObject[i].Videoindex == index){
        //       this.VideoObject.splice(i,1)
        //       break;
        //     }
        //   }
        //   item.show = 0.5
        // }
        //新程式     
        if(this.CheckCameraState(index) == 1){
          var deleteIndex = this.VideoObject.findIndex(function(item) {
            return item.Videoindex === index;
          });
          
          if (deleteIndex !== -1) {
            this.VideoObject.splice(deleteIndex, 1);
          } else {
            console.log("Item not found!");
          }
        }else{
          var MDVRID = ''
          //鏡頭名稱
          var lensName = ''
          if(item.mdvrjson != null){
            if(item.mdvrjson.MDVRJsonObj[index].Name == null || item.mdvrjson.MDVRJsonObj[index].Name ==''){
              lensName = Vue.prototype.$Global.OneConvertToFirst(index+1)+' '+Vue.prototype.$Global.langObj[Vue.prototype.$Global.lang].lens
            }else{
              lensName = item.mdvrjson.MDVRJsonObj[index].Name
            }
          }else{
            lensName = Vue.prototype.$Global.OneConvertToFirst(index+1)+' '+Vue.prototype.$Global.langObj[Vue.prototype.$Global.lang].lens
          }
          if(item.mdvrid != null || item.mdvrid != ''){
            MDVRID = item.mdvrid
          }
          this.VideoObject.push(
          {
            // src:jsonObject.MDVRAPIUrl+"/command/live?id="+MDVRID+"&ch="+index,
            src:jsonObject.ConvertToHttpUrl+"?mode=live&id="+MDVRID+"&ch="+index,
            Name:lensName,
            Videoindex:index
          })
        }
        this.VideoObjectShow = true
        if(this.VideoObject.length == 0){
          this.VideoObjectShow = false
        }
      },
      //確認攝影機目前狀態
      CheckCameraState(index){
        for(var i = 0 ; i<this.VideoObject.length;i++){
          if(this.VideoObject[i].Videoindex == index){
            return 1
          }
        }
        return 0
      },
      //設定攝影機連線狀態圖
      // setCameraConnection(){
      //   if(this.ClickUnitInfo.cameraStatus == 0){//表示Camera離線
      //     for(var i =0;i<this.ClickUnitInfo.numberOfLenses;i++){
      //       var lensname = ''
      //       lensname = Vue.prototype.$Global.OneConvertToFirst(i+1)
      //       Vue.prototype.$set(this.UnitVideoShow[i],'show',0.3)
      //       Vue.prototype.$set(this.UnitVideoShow[i],'cursor','')
      //       Vue.prototype.$set(this.UnitVideoShow[i],'title',Vue.prototype.$Global.langObj[Vue.prototype.$Global.lang].Offline+' '+lensname+' '+Vue.prototype.$Global.langObj[Vue.prototype.$Global.lang].lens)
      //     }
      //   }
      //   // console.log(this.ClickUnitInfo.cameraStatus)
      //   // console.log(this.ClickUnitInfo.numberOfLenses)
      // },
      //設定車輛攝影機圖
      // setUnitVideoShow(){
      //   this.resetUnitVideoShow()
      //   if(this.ClickUnitInfo.numberOfLenses > 0){
      //     for(var i =0;i<this.ClickUnitInfo.numberOfLenses;i++){
      //       var lensname = ''
      //       lensname = Vue.prototype.$Global.OneConvertToFirst(i+1)
      //       Vue.prototype.$set(this.UnitVideoShow[i],'show',0.5)
      //       Vue.prototype.$set(this.UnitVideoShow[i],'cursor','pointer')
      //       Vue.prototype.$set(this.UnitVideoShow[i],'title',lensname+' '+Vue.prototype.$Global.langObj[Vue.prototype.$Global.lang].lens)
      //     }
      //   }
      // },
      //重設車輛攝影機圖
      // resetUnitVideoShow(){
      //   for(var i =0;i<this.UnitVideoShow.length;i++){
      //     Vue.prototype.$set(this.UnitVideoShow[i],'show',0.1)
      //     Vue.prototype.$set(this.UnitVideoShow[i],'cursor','not-allowed')
      //     Vue.prototype.$set(this.UnitVideoShow[i],'title',Vue.prototype.$Global.langObj[Vue.prototype.$Global.lang].none_Lens)
      //   }
      // },
      //排序車輛資訊
      UnitInfoSort(UnitInfoList){
        var SortedUnitInfoList = Vue.prototype.$Global.sortByKey(UnitInfoList,'identifier')
        var UnitInfo = []
        var NodataUnit = []
        for(var i = 0 ; i<SortedUnitInfoList.length ; i++){
          if(SortedUnitInfoList[i].resource==null && SortedUnitInfoList[i].reportId == null){//Nodata
            NodataUnit.push(SortedUnitInfoList[i])
          }else{
            UnitInfo.push(SortedUnitInfoList[i])
          }
        }
        var UnitInfo = UnitInfo.concat(NodataUnit)
        return UnitInfo
      },
      //設定狀態燈號圖片
      setStatusImg(i,UnitInfoList){
        switch (UnitInfoList[i].connectionState) {//給狀態圖
          case 0:
            UnitInfoList[i].imgsrc = require('@/assets/svg/status_offline_stall.svg')
            break;
          case 1:
            if(UnitInfoList[i].accState == 0){
              UnitInfoList[i].imgsrc = require('@/assets/svg/status_stall.svg')
            }else{
              UnitInfoList[i].imgsrc = require('@/assets/svg/status_active.svg')
            }
            if(UnitInfoList[i].State){
              if(UnitInfoList[i].State == 'Idle'){
                UnitInfoList[i].imgsrc = require('@/assets/svg/status_idle_stall.svg')
              }
            }
            break;          
          default:
            UnitInfoList[i].imgsrc = require('@/assets/svg/status_stall.svg')
            break;
        }
        if(UnitInfoList[i].Iconcheckbox == 'Iconcheckboxdisabled'){
          UnitInfoList[i].imgsrc = ""    
        }
      },
      //設定事件顏色 index版
      setEventColor(i,UnitInfoList){
        Vue.prototype.$Global.EventDefChangeColor(UnitInfoList[i].eventType,UnitInfoList[i])
      },
      //設定車輛列表Checkbox狀態
      setUnitCheckbox(i,UnitInfoList){
        //判斷是不是nodata
        var hasData = 0
        for(var j = 0 ; j <this.UnitIDsSubPageObj.length;j++){
          if(this.UnitIDsSubPageObj[j].unitId == UnitInfoList[i].unitId){
            if(this.UnitIDsSubPageObj[j].hasData == 1){
              hasData = 1
            }
            break;
          }
        }
        if(hasData == 1){//是不是No data 或 經緯度是不是0
          Vue.prototype.$set(UnitInfoList[i],'checkbox','false')
          Vue.prototype.$set(UnitInfoList[i],'Iconcheckbox','Iconcheckbox')//set checkbox
        }else{
          Vue.prototype.$set(UnitInfoList[i],'Iconcheckbox','Iconcheckboxdisabled')
        }
        if((UnitInfoList[i].latitude == 0 && UnitInfoList[i].longitude == 0)){//經緯度等於0,0
          Vue.prototype.$set(UnitInfoList[i],'Iconcheckbox','Iconcheckboxdisabled')
        }
        if(this.WatchUnit == null || this.WatchUnit == undefined || this.WatchUnit.length == 0|| this.WatchUnit == '' || this.ClearWatchUnit){
          this.UnitListDetailShow = false//關閉車輛屬性框
          this.CommandShow = false //關閉Command
        }else{
          var WatchUnit = this.WatchUnit
          for(var j =0 ;j <WatchUnit.length ; j++){
            if(UnitInfoList[i].unitId == WatchUnit[j]){
              Vue.prototype.$set(UnitInfoList[i],'checkbox','true')
              Vue.prototype.$set(UnitInfoList[i],'Iconcheckbox','Iconcheckbox-active')
            }
          }
        }
      },
      //車輛Obj轉車輛Arr
      UnitObjConvertUnitArr(UnitIDsObj){
        var UnitIDsArr = []
        for(var i=0 ; i<UnitIDsObj.length ;i++){
          UnitIDsArr.push(UnitIDsObj[i].unitId)
        }
        return UnitIDsArr
      },
      //取得當頁UnitInfo
      getUnitIDsSubInfo(){
        this.Allnum = this.UnitIDsArr.length //全車輛數
        //取得當前TimeZone
        this.TimeZone = Vue.prototype.$Global.getTimeZone(this.FleetID)
        //SignalR 停止
        Vue.prototype.$SignalRjs.ConnectionStop()
        //SignalR 連接
        Vue.prototype.$SignalRjs.ConnectionSignalR()
        //等待連接成功
        setTimeout(() => {
          //SignalR 開始
          Vue.prototype.$SignalRjs.ConnectionStart() 
        }, 1000);
        //signalR連不上處理
        setTimeout(() => {
          this.handleSignalRNoConnecttion()
          this.SignalRCallNum++
        }, 5000);
      },
      //處理SignalR沒連接上
      handleSignalRNoConnecttion(){
        if(!Vue.prototype.$Global.load || this.SignalRCallNum >=3){
          console.log('test SignalRNoConnecttion 1')
          Vue.prototype.$Global.Noneactive = ''
          Vue.prototype.$Global.load = false
        }else{
          console.log('test SignalRNoConnecttion 2')
          this.getUnitIDsSubInfo()
        }
      },
      //設定事件顏色 物件版
      setEventInfoColor(item){
        for(var i =0 ;i<item.length;i++){
          Vue.prototype.$Global.EventDefChangeColor(item[i].eventType,item[i])
        }
      },
      //設定車機資訊及狀態
      setUnitInfoStatus(UnitInfoList){
        for(var i=0 ; i<UnitInfoList.length;i++){
          // this.setEventColor(i,UnitInfoList)
          this.setStateTime(i,UnitInfoList)
          this.setStateColor(i,UnitInfoList)
          this.setUnitCheckbox(i,UnitInfoList)
          this.setStatusImg(i,UnitInfoList)
          this.setFleetName(i,UnitInfoList)
          this.setProtoCode(i,UnitInfoList)
          this.setFavorite(i,UnitInfoList)
          this.setLineState(i,UnitInfoList)
          this.setOneWire(i,UnitInfoList)
          this.setMDVR(i,UnitInfoList)
        }
        this.UnitInfoList = UnitInfoList
      },
      //設定MDVR
      setMDVR(i,UnitInfoList){
        for(var j = 0 ; j <this.UnitIDsSubPageObj.length;j++){
          if(this.UnitIDsSubPageObj[j].unitId == UnitInfoList[i].unitId){
            UnitInfoList[i].mdvrid = this.UnitIDsSubPageObj[j].mdvrid
            if(this.UnitIDsSubPageObj[j].mdvrjson != null){
              UnitInfoList[i].mdvrjson = JSON.parse(this.UnitIDsSubPageObj[j].mdvrjson)
            }
            if((UnitInfoList[i].mdvrid == null || UnitInfoList[i].mdvrid == '') && UnitInfoList[i].protoCode == 'MDVR'){
              UnitInfoList[i].mdvrid = this.UnitIDsSubPageObj[j].modemID
            }
            break;
          }
        }
      },
      //設定溫度計
      setOneWire(index,UnitInfoList){
        if(UnitInfoList[index].wireLogDateTime != null){
          if(Vue.prototype.$Global.differenceCurrentTime(UnitInfoList[index].wireLogDateTime)/ (1000 * 60) > 10){
            UnitInfoList[index].tsD1 = null 
            UnitInfoList[index].tsD2 = null
            UnitInfoList[index].tsD3 = null
            UnitInfoList[index].tsD4 = null
          }
        }else{
          UnitInfoList[index].tsD1 = null 
          UnitInfoList[index].tsD2 = null
          UnitInfoList[index].tsD3 = null
          UnitInfoList[index].tsD4 = null
        }
        //別名設定
        for(var y =1 ; y <=4 ; y++){
          UnitInfoList[index]['tsName'+y] = null
        }
        for(var i = 0 ; i<this.UnitIDsSubPageObj.length;i++){
          if(UnitInfoList[index].unitId == this.UnitIDsSubPageObj[i].unitId){
            if(this.UnitIDsSubPageObj[i].oneWireJSON != null && this.UnitIDsSubPageObj[i].oneWireJSON!=''){
              try{
                var OneWireJSONObj = JSON.parse(this.UnitIDsSubPageObj[i].oneWireJSON)
                for(var x = 0 ; x<OneWireJSONObj.length;x++){                
                  for(var y =1 ; y <=4 ; y++){
                    if(UnitInfoList[index]['tsI'+y] == OneWireJSONObj[x].ID){
                      UnitInfoList[index]['tsName'+y] = OneWireJSONObj[x].Name
                    }
                  }
                }
              }catch(e){
                console.log(e)
              }
            }
          }
        }
      },
      //設定Line
      setLineState(index,UnitInfoList){
        for(var i = 0 ; i<this.UnitLineStateList.length;i++){
          if(UnitInfoList[index].unitId == this.UnitLineStateList[i].fK_UnitID){
            UnitInfoList[index].lineState = this.UnitLineStateList[i].lineState
            break
          }
        }
      },
      //設定車輛各狀態顏色
      setStateColor(index,UnitInfoList){
        if(UnitInfoList[index].connectionState == 0){
          UnitInfoList[index].color = 'gray'
        }else{
          switch (UnitInfoList[index].accState) {
            case 0:
              UnitInfoList[index].color = 'blue'
              break;
            case 1:
              UnitInfoList[index].color = 'green'
              if(UnitInfoList[index].State){
                if(UnitInfoList[index].State == 'Idle'){
                  UnitInfoList[index].color = 'orange'
                }
              }
              break; 
            default:
              UnitInfoList[index].color = 'green'
              break;
          }
        }
      },
      //設定狀態時間
      setStateTime(index,UnitInfoList){
        //計算Idle or ACCOn or ACCOff多久
        var differenceMilliSec;
        //Idle 
        if(UnitInfoList[index].lastIdleStartDateTime != null && UnitInfoList[index].accState == 1){
            differenceMilliSec = Vue.prototype.$Global.differenceCurrentTime(UnitInfoList[index].lastIdleStartDateTime)
            UnitInfoList[index].State = 'Idle'
        }
        //ACCOn
        else if(UnitInfoList[index].lastIdleStartDateTime == null && UnitInfoList[index].accState == 1 && UnitInfoList[index].lastAccOnDateTime != null){
            differenceMilliSec = Vue.prototype.$Global.differenceCurrentTime(UnitInfoList[index].lastAccOnDateTime)
            UnitInfoList[index].State = 'ACCOn'
        }
        //ACCOff
        else if(UnitInfoList[index].lastAccOffDateTime !=null && UnitInfoList[index].accState == 0){
            differenceMilliSec = Vue.prototype.$Global.differenceCurrentTime(UnitInfoList[index].lastAccOffDateTime)
            UnitInfoList[index].State = 'ACCOff'
        }else{
            UnitInfoList[index].State = null
        }
        if(differenceMilliSec != undefined){
            //如果大於100天
            if(differenceMilliSec>=(86400000*100)){
                UnitInfoList[index].StateTime = '99d:23h:59m'
            }
            //如果大於1天
            else if(differenceMilliSec > 86400000){
                var day = (differenceMilliSec / 86400000).toFixed(0) + 'd'
                var hr;
                var min;
                if((differenceMilliSec % 86400000) > 3600000){
                    hr = ((differenceMilliSec % 86400000)/3600000).toFixed(0) + 'h'
                    min = (((differenceMilliSec % 86400000) % 3600000) / 60000).toFixed(0) + 'm'
                }else{
                    hr = '0h'
                    min = ((differenceMilliSec % 86400000) / 60000).toFixed(0) + 'm'
                }
                UnitInfoList[index].StateTime = day + ':' + hr + ':' + min
            }else if (differenceMilliSec > 3600000 && differenceMilliSec <= 86400000){
                var hr = (differenceMilliSec / 3600000).toFixed(0)
                var min = ((differenceMilliSec % 3600000)/60000).toFixed(0)
                // UnitInfoList[index].StateTime ='0d:'+ hr +'h:' + min +'m'
                UnitInfoList[index].StateTime =hr +'h:' + min +'m'
            }else{
                var min = (differenceMilliSec/60000).toFixed(0)
                // UnitInfoList[index].StateTime = '0d:'+'0h:'+ min +'m'
                UnitInfoList[index].StateTime = min +'m'
            }
        }else{
            UnitInfoList[index].StateTime = null
        }
      },
      //設定車機我最愛
      setFavorite(index,UnitInfoList){
        var favorite = 0
        if(Vue.prototype.$Global.FavoriteUnitObj){
          for(var i = 0 ; i<Vue.prototype.$Global.FavoriteUnitObj.length ;i++){
            if(Vue.prototype.$Global.FavoriteUnitObj[i].unitId == UnitInfoList[index].unitId){
              favorite = 1
              break;
            }
          }
        }
        Vue.prototype.$set(UnitInfoList[index],'favorite',favorite)
      },
      //加入車機ProtoCode
      setProtoCode(index,UnitInfoList){
        //將ProtoCode填入UnitInfoList
        var protoCode = Vue.prototype.$Global.PrtoIDtoProtoCode(UnitInfoList[index].fK_ProtoID)
        Vue.prototype.$set(UnitInfoList[index],'protoCode',protoCode)
        // console.log(UnitInfoList[index].protoCode)
      },
      //車隊名稱填入屬性框
      setFleetName(index,UnitInfoList){
        //將FleetName填入UnitInfoList
        if(this.UnitIDs){
          for(var i=0 ; i <this.UnitIDs.length ; i++){
            if(this.UnitIDs[i].unitId == UnitInfoList[index].unitId){
              Vue.prototype.$set(UnitInfoList[index],'fleetName',this.UnitIDs[i].fleetName)
              Vue.prototype.$set(UnitInfoList[index],'fleetID',this.UnitIDs[i].fleetID)
              break;
            }
          }
        }
      },
      //取得當頁unitID
      GetUnitIDsSub(status){
        this.UnitIDsSubPageObj = []
        var UnitHighNumber;
        if(status == 'pre' || status=='next'){
          UnitHighNumber = this.CurrentPageHighNumber
        }else{
          UnitHighNumber = parseInt(localStorage.getItem('UnitHighNumber'))
        }
        var start = (this.CurrentUnitPage-1)*UnitHighNumber
        var end = (this.CurrentUnitPage-1)*UnitHighNumber + UnitHighNumber
        //如果是最後一頁
        if(this.UnitPageNum == this.CurrentUnitPage){
          end = this.UnitIDs.length
        }
        for(var i = start ; i < end ; i++){
          this.UnitIDsSubPageObj.push(this.UnitIDs[i])
        }
      },
      //追蹤頁換頁
      ChangeUnitPage(status){
        this.FirstData = true
        switch (status) {
          case 'pre':
            if(this.CurrentUnitPage > 1){
              Vue.prototype.$Global.Noneactive = 'None-active'
              Vue.prototype.$Global.load = true
              this.UnitListDetailShow = false//關閉車輛屬性框
              this.CommandShow = false //關閉Command
              //this.SearchCartip = true
              this.CurrentUnitPage--
              this.GetUnitIDsSub(status)
              this.UnitIDsArr = this.UnitObjConvertUnitArr(this.UnitIDsSubPageObj)
              this.getUnitIDsSubInfo(this.UnitIDsArr)
              // this.getUnitIDEventInfo(this.UnitIDsArr)
              this.CloseVideo()
            }
            break;
          case 'next':
            if(this.CurrentUnitPage < this.UnitPageNum){
              Vue.prototype.$Global.Noneactive = 'None-active'
              Vue.prototype.$Global.load = true
              this.UnitListDetailShow = false//關閉車輛屬性框
              this.CommandShow = false //關閉Command
              //this.SearchCartip = true
              this.CurrentUnitPage++
              this.GetUnitIDsSub(status)
              this.UnitIDsArr = this.UnitObjConvertUnitArr(this.UnitIDsSubPageObj)
              this.getUnitIDsSubInfo(this.UnitIDsArr)
              // this.getUnitIDEventInfo(this.UnitIDsArr)
              this.CloseVideo()
            }
            break;
          case 'first':
            if(this.CurrentUnitPage > 1){
              Vue.prototype.$Global.Noneactive = 'None-active'
              Vue.prototype.$Global.load = true
              this.UnitListDetailShow = false//關閉車輛屬性框
              this.CommandShow = false //關閉Command
              //this.SearchCartip = true
              this.CurrentUnitPage = 1
              this.GetUnitIDsSub(status)
              this.UnitIDsArr = this.UnitObjConvertUnitArr(this.UnitIDsSubPageObj)
              this.getUnitIDsSubInfo(this.UnitIDsArr)
              // this.getUnitIDEventInfo(this.UnitIDsArr)
              this.CloseVideo()
            }
            break;   
          case 'last':
            if(this.CurrentUnitPage < this.UnitPageNum){
              Vue.prototype.$Global.Noneactive = 'None-active'
              Vue.prototype.$Global.load = true
              this.UnitListDetailShow = false//關閉車輛屬性框
              this.CommandShow = false //關閉Command
              //this.SearchCartip = true
              this.CurrentUnitPage = this.UnitPageNum
              this.GetUnitIDsSub(status)
              this.UnitIDsArr = this.UnitObjConvertUnitArr(this.UnitIDsSubPageObj)
              this.getUnitIDsSubInfo(this.UnitIDsArr)
              // this.getUnitIDEventInfo(this.UnitIDsArr)
              this.CloseVideo()
            }
            break;  
          default:
            break;
        }
      },
      //Google map, SignalR來處理追蹤車輛
      GoogleSignalRFixwatchUnit(){
        var WatchUnitObj = this.getWatchUnit()
        var WatchUnit = []
        for(var i = 0 ;i < WatchUnitObj.length ; i++){
          WatchUnit.push(WatchUnitObj[i].unitId)
        }
        this.WatchUnit = WatchUnit
        this.WatchUnitObj = WatchUnitObj
      },
      //變更車輛列表選取資訊
      ChangeUnitInfo(){
        var WatchUnitObj = this.getWatchUnit()
        var WatchUnit = []
        for(var i = 0 ;i < WatchUnitObj.length ; i++){
          WatchUnit.push(WatchUnitObj[i].unitId)
        }
        this.WatchUnit = WatchUnit
        this.WatchUnitObj = WatchUnitObj
        Vue.prototype.$Global.AddUnitMarker()
      },
      //取的追蹤車輛
      getWatchUnit(){
        var WatchUnitObj = Vue.prototype.$Global.JsonFilter('true',this.UnitInfoList,'checkbox')
        return WatchUnitObj
      },
    }
  }
}




// WEBPACK FOOTER //
// ./src/Vehicle.js